import { render, staticRenderFns } from "./TreeInfoPicture.vue?vue&type=template&id=49d54c88&scoped=true&"
import script from "./TreeInfoPicture.vue?vue&type=script&lang=ts&"
export * from "./TreeInfoPicture.vue?vue&type=script&lang=ts&"
import style0 from "./TreeInfoPicture.vue?vue&type=style&index=0&id=49d54c88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d54c88",
  null
  
)

export default component.exports